// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-containers-Assets-AssetDetail-___AssetDetail-module__container {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.app-containers-Assets-AssetDetail-___AssetDetail-module__topContent {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.app-containers-Assets-AssetDetail-___AssetDetail-module__image {
  margin-right: 15px;
}

.app-containers-Assets-AssetDetail-___AssetDetail-module__image img {
    border-radius: 3px;
    display: block;
    max-width: 80px;
    max-height: 50px;
    cursor: pointer;
  }

.app-containers-Assets-AssetDetail-___AssetDetail-module__image img:hover {
  opacity: 0.8;
}

.app-containers-Assets-AssetDetail-___AssetDetail-module__infos {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-self: stretch;
  align-items: flex-start;
}

.app-containers-Assets-AssetDetail-___AssetDetail-module__name {
  display: flex;
  align-items: center;
  align-content: center;
  flex-direction: row;
  flex-wrap: nowrap;
  font: 26px 'ralewaybold';
  height: 100%;
}

.app-containers-Assets-AssetDetail-___AssetDetail-module__label {
  margin-right: 5px;
  font-family: 'ralewaybold';
}

.app-containers-Assets-AssetDetail-___AssetDetail-module__removed {
  font-size: 28px;
  background-color: red;
  border-radius: 10px;
  color: #ffffff;
  padding: 0 20px;
  font-weight: bold;
}

:root {
  --border: solid 1px var(--colors-greyLight);
}

.app-containers-Assets-AssetDetail-___AssetDetail-module__tabs {
  margin-top: 10px;
  background-color: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: inherit;
}

.app-containers-Assets-AssetDetail-___AssetDetail-module__tabItem {
  flex: 1;
}

.app-containers-Assets-AssetDetail-___AssetDetail-module__tabsRouter {
  display: flex;
  overflow: hidden;
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./app/containers/Assets/AssetDetail/AssetDetail.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AASpB;;AAPE;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;AAGF;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,OAAO;AACT","sourcesContent":[".container {\n  box-sizing: border-box;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.topContent {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.image {\n  margin-right: 15px;\n\n  img {\n    border-radius: 3px;\n    display: block;\n    max-width: 80px;\n    max-height: 50px;\n    cursor: pointer;\n  }\n}\n\n.image img:hover {\n  opacity: 0.8;\n}\n\n.infos {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-self: stretch;\n  align-items: flex-start;\n}\n\n.name {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  font: 26px 'ralewaybold';\n  height: 100%;\n}\n\n.label {\n  margin-right: 5px;\n  font-family: 'ralewaybold';\n}\n\n.removed {\n  font-size: 28px;\n  background-color: red;\n  border-radius: 10px;\n  color: #ffffff;\n  padding: 0 20px;\n  font-weight: bold;\n}\n\n:root {\n  --border: solid 1px var(--colors-greyLight);\n}\n\n.tabs {\n  margin-top: 10px;\n  background-color: #fff;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  height: inherit;\n}\n\n.tabItem {\n  flex: 1;\n}\n\n.tabsRouter {\n  display: flex;\n  overflow: hidden;\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-containers-Assets-AssetDetail-___AssetDetail-module__container`,
	"topContent": `app-containers-Assets-AssetDetail-___AssetDetail-module__topContent`,
	"image": `app-containers-Assets-AssetDetail-___AssetDetail-module__image`,
	"infos": `app-containers-Assets-AssetDetail-___AssetDetail-module__infos`,
	"name": `app-containers-Assets-AssetDetail-___AssetDetail-module__name`,
	"label": `app-containers-Assets-AssetDetail-___AssetDetail-module__label`,
	"removed": `app-containers-Assets-AssetDetail-___AssetDetail-module__removed`,
	"tabs": `app-containers-Assets-AssetDetail-___AssetDetail-module__tabs`,
	"tabItem": `app-containers-Assets-AssetDetail-___AssetDetail-module__tabItem`,
	"tabsRouter": `app-containers-Assets-AssetDetail-___AssetDetail-module__tabsRouter`
};
export default ___CSS_LOADER_EXPORT___;
